import { cn } from "@/lib/utils";

export const Row = ({
  title,
  value,
  hiddenBorder = false,
  height = "h-10",
  stretch = false,
}: {
  title: string;
  value: React.ReactNode;
  hiddenBorder?: boolean;
  height?: string;
  stretch?: boolean;
}) => {
  return (
    <div className={cn("flex flex-col px-4", height, "items-center text-xs")}>
      <div className="flex flex-row w-full justify-between h-full items-center">
        <p className="text-dark-tertiary">{title}</p>
        <div className="text-dark-secondary">{value || ""}</div>
      </div>
      {!hiddenBorder && (
        <div
          className={cn(
            "h-[1px] bg-panel-base",
            stretch
              ? "-mr-4 touch-device:-mr-8 w-[calc(100%+1rem)] touch-device:w-[calc(100%+2rem)]"
              : "w-full",
          )}
        />
      )}
    </div>
  );
};
